import moment from 'moment';
import { dateTimeFormat } from '@/ts/DefaultTableConfigs';

export default class EditPresentationParticipantData {
    public id: number;
    public createdAt: string;
    public interestedFrom: string;
    public name: string;
    public email: string;
    public phone: string;
    public language: string;
    public priority: string;
    public interested: any;

    constructor(
        id: number,
        createdAt: string,
        interestedFrom: string,
        firstName: string,
        lastName: string,
        email: string,
        phone: string,
        language: string,
        priority: string,
        interested: any,
    ) {
        this.id             = id;
        this.interestedFrom = interestedFrom !== null ? interestedFrom : '';
        this.createdAt      = createdAt !== null ? moment(createdAt).local().format(dateTimeFormat) : '';
        this.name           = `${firstName} ${lastName}`;
        this.email          = email;
        this.phone          = phone;
        this.language       = language === 'dk' ? 'DA' : 'EN';
        this.priority       = priority === 'on' ? 'Yes' : 'No';

        switch (interested) {
            case 0:
                this.interested = 'No';
                break;
            case 1:
                this.interested = 'Yes';
                break;
            default:
                this.interested = 'Pending';
        }
    }
}
